import { render, staticRenderFns } from "./AppCartSteps.vue?vue&type=template&id=6f2064b6&scoped=true"
import script from "./AppCartSteps.vue?vue&type=script&lang=ts"
export * from "./AppCartSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2064b6",
  null
  
)

export default component.exports